<template>
  <div id="app">
    <router-view></router-view>

    <!-- 只有登录状态且路径不是 /episode 及其子路径时显示 Header3 -->
    <Header3 v-if="loggedIn && !isEpisodePath" />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, provide } from 'vue'
import { useRoute } from 'vue-router'
import Header3 from './components/Header3.vue'
import { isLoggedIn } from './router.js'
import { API_ENDPOINTS } from './api.js'

import { useDeviceDetection } from './components/useDeviceDetection.js'

// 使用 composable
const { isMobile } = useDeviceDetection()

const loggedIn = ref(false)
const route = useRoute()
const siteInfo = ref(null)

function checkLogin() {
  loggedIn.value = isLoggedIn()
}

// 获取网站信息
async function fetchSiteInfo() {
  try {
    const res = await fetch(API_ENDPOINTS.info)
    const data = await res.json()
    if (data.code === 200 && data.data?.site_info) {
      siteInfo.value = data.data.site_info
      // 更新页面标题
      if (data.data.site_info.title) {
        document.title = data.data.site_info.title
      }
    }
  } catch (err) {
    console.error('Failed to fetch site info:', err)
  }
}

// 提供 siteInfo 给子组件
provide('siteInfo', siteInfo)

// 计算当前路径是否是 /episode 或其子路径
const isEpisodePath = computed(() => {
  console.log('路径:', route.path)  // 输出路径，确保它是小写的 '/episode'
  return route.path.toLowerCase().startsWith('/episode')
})
watch(
  () => route.fullPath,
  () => checkLogin(),
  { immediate: true }
)

onMounted(() => {
  checkLogin()
  fetchSiteInfo()

  // 监听 localStorage 变化（登录登出时触发）
  window.addEventListener('storage', (event) => {
    if (event.key === 'token') {
      checkLogin()
    }
  })
})

// 监听路由变化，确保 isEpisodePath 计算属性更新（useRoute 本身响应式，这里可选）
watch(() => route.path, () => {
  // 这里可以做额外操作，如果需要
})
</script>
